export default __webpack_public_path__ + "static/media/electric-shower.b9d81645.svg";